module.exports = __webpack_public_path__ + "img/exit.eb4ffa0.svg";